import React from "react";
import { makeStyles } from "tss-react/mui";
const useLayoutDetailsClasses = makeStyles()((theme) => ({
  layoutDetails: {
    overflowY: "hidden",
    height: "100%"
  },
  layoutDetailsBody: {
    width: "100%",
    display: "flex",
    margin: 0,
    padding: theme.spacing(2.5, 5),
    columnGap: theme.spacing(2.5),
    justifyContent: "center",
    height: `calc(100% - ${theme.custom.pageHeaderHeight}px)`,
    [theme.breakpoints.down("md")]: {
      height: `calc(100% - ${theme.custom.pageHeaderHeight + theme.custom.smallSizesNavbarHeight}px)`
    }
  },
  layoutDetailsPrimaryInfo: {
    flexGrow: 1,
    overflowY: "auto",
    overflowX: "hidden",
    "& > :nth-child(n)": {
      marginBottom: theme.spacing(2),
      "&.Mui-expanded": {
        marginBottom: theme.spacing(2)
      }
    }
  },
  layoutDetailsPrimaryInfoWidthLg: {
    maxWidth: "1080px"
  },
  layoutDetailsSecondaryInfo: {
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    rowGap: theme.spacing(1.25),
    marginLeft: "auto",
    flexShrink: 0,
    position: "relative",
    top: 0,
    bottom: 0,
    maxWidth: "33.333%",
    width: "33.333%"
  }
}));
const LayoutDetails = ({
  header,
  primaryInfo,
  secondaryInfoTop,
  secondaryInfoBottom,
  primaryInfoWidth = "full"
}) => {
  const { classes, cx } = useLayoutDetailsClasses();
  const hasSecondaryInfo = Boolean(secondaryInfoTop) || Boolean(secondaryInfoBottom);
  return /* @__PURE__ */ React.createElement("div", { className: classes.layoutDetails }, header, /* @__PURE__ */ React.createElement("div", { className: classes.layoutDetailsBody }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(classes.layoutDetailsPrimaryInfo, {
        [classes.layoutDetailsPrimaryInfoWidthLg]: primaryInfoWidth === "lg"
      })
    },
    primaryInfo
  ), hasSecondaryInfo ? /* @__PURE__ */ React.createElement("div", { className: classes.layoutDetailsSecondaryInfo }, secondaryInfoTop, secondaryInfoBottom) : null));
};
export {
  LayoutDetails
};
//# sourceMappingURL=LayoutDetails.js.map
